import { render, staticRenderFns } from "./Prestamo.vue?vue&type=template&id=0c5c61ce&scoped=true"
import script from "./Prestamo.vue?vue&type=script&lang=js"
export * from "./Prestamo.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Prestamo.vue?vue&type=style&index=2&id=0c5c61ce&prod&lang=css"
import style3 from "./Prestamo.vue?vue&type=style&index=3&id=0c5c61ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c61ce",
  null
  
)

export default component.exports